/* eslint-disable no-useless-escape */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FlexContainer } from '@edulastic/common'
import styled from 'styled-components'
import { title, lightGrey4, themeColor } from '@edulastic/colors'
import { sanitizeUrl } from '@edulastic/common/src/utils/html'
import TokenizedYouTubePlayer from '@edulastic/common/src/components/TokenizedYouTubePlayer'
import EdulasticResourceModal from '../../../../../../../CurriculumSequence/components/ManageContentBlock/components/common/EdulasticResourceModal'

const EmbeddedSplitPaneModal = (props) => {
  const { isVisible: data, windowWidth } = props
  const { sections = [] } = data || {}

  const menuItems = sections.map((x) => x.title)

  const [activeItem, setActiveItem] = useState({ ...sections[0], index: 0 })

  return (
    <EdulasticResourceModal headerText={data?.title} {...props} hideFooter>
      <FlexContainer padding="10px 0px">
        <LeftPane>
          {menuItems.map((label, i) => (
            <LeftPaneItem
              data-cy={label}
              key={i}
              onClick={() => setActiveItem({ ...sections[i], index: i })}
              active={i === activeItem.index}
            >
              {label === 'Track Student Performance Data'
                ? 'Track Student Performance'
                : label}
            </LeftPaneItem>
          ))}
        </LeftPane>
        <RightPane>
          {activeItem.renderType === 'video' ? (
            // Only youtube links supported for now as per requirement.
            // Uses the tokenized v2 player so it works on domains where YouTube
            // enforces Embedder Identity (tokenless iframes fail with error 152).
            <TokenizedYouTubePlayer
              key={activeItem.url}
              data-cy="videoLink"
              url={activeItem.url}
              width={windowWidth <= 1024 ? '625px' : '750px'}
              height={windowWidth <= 1024 ? '352px' : '422px'}
              playerVars={{
                utm_source: 'Application',
                utm_medium: 'Clicks',
                utm_campaign: 'Dashboard_Quick_Start_Overview',
              }}
            />
          ) : (
            <ListItems>
              {activeItem.links.map((content, i) => (
                <a
                  data-cy={content.title}
                  key={i}
                  href={sanitizeUrl(content.url)}
                  target="_blank"
                  rel="noreferrer"
                >
                  {content.title}
                </a>
              ))}
            </ListItems>
          )}
        </RightPane>
      </FlexContainer>
    </EdulasticResourceModal>
  )
}

EmbeddedSplitPaneModal.propTypes = {
  closeCallback: PropTypes.func.isRequired,
  modalWidth: PropTypes.string.isRequired,
  titleFontSize: PropTypes.string.isRequired,
  padding: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
}

export default EmbeddedSplitPaneModal

const LeftPaneItem = styled.div`
  border-left: ${(props) =>
    props.active ? `4px solid ${themeColor}` : 'none'};
  color: ${(props) => (props.active ? themeColor : title)};
  width: 100%;
  height: 30px;
  line-height: 30px;
  padding-left: ${(props) => (props.active ? '16px' : '20px')};
  font-size: 15px;
  font-weight: 600;
  margin-top: 12px;
  cursor: pointer;
`

const LeftPane = styled.div`
  width: 330px;
  border-right: 1px solid ${lightGrey4};
`

const RightPane = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 25px 20px 25px;
`

const ListItems = styled.div`
  width: 100%;
  min-height: 293px;
  text-align: left;
  padding-left: 70px;

  a {
    display: block;
    width: 100%;
    color: ${themeColor};
    font-size: 16px;
    font-weight: 600;
    margin-top: 15px;
  }
`
